/* unplugin-vue-components disabled */import script from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommonForm.vue?vue&type=style&index=0&id=0074b1f9&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0074b1f9"]])

export default __exports__